module.exports = __webpack_public_path__ + "static/media/icon_energy_work.cd6209c5.svg";